export const getToken = () => {
	const token = localStorage.getItem('token') ?? null;
	const id = localStorage.getItem('id') ?? null;
	const _token = localStorage.getItem('_token') ?? null;

	return { token, id, _token };
};
